import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Nav from "./Navigation.js";
import { getTokenInternal } from "./useToken";

export default function SubmitSuggestion() {
  const [token, setToken] = useState();
  const [message, setMessage] = useState("");
  const [submitError, setSubmitError] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const init = async () => {
      const fetchedToken = await getTokenInternal();
      if (!fetchedToken) {
        navigate("/login");
        return;
      }
      setToken(fetchedToken);
    };
    init();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError("");
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/suggestions/create`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ message }),
        }
      );
      if (!response.ok) {
        throw new Error("Could not submit your suggestion");
      }
      setMessage("");
      setSubmitted(true);
    } catch (error) {
      setSubmitError(error.message);
    }
  };

  if (!token) {
    return null;
  }

  return (
    <div className="text-white">
      <Nav />
      <div className="container mx-auto p-4 max-w-xl">
        <h1 className="text-2xl font-bold mb-4">Send Feedback</h1>
        <form onSubmit={handleSubmit}>
          <textarea
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
              setSubmitted(false);
            }}
            required
            rows={6}
            placeholder="What's on your mind? Bugs, confusing UI, wrong translations, feature ideas -- all welcome."
            className="w-full p-2 border rounded text-black"
          />
          <button type="submit" className="mt-2 p-1 border rounded">
            Submit
          </button>
        </form>

        {submitted && (
          <p className="text-green-400 mt-2">Thanks! Your feedback has been submitted.</p>
        )}
        {submitError && <p className="text-red-500 mt-2">{submitError}</p>}

        <p className="text-gray-400 text-sm mt-8">
          If you need to contact me directly, you can via Discord: @ShandaDaPanda
        </p>
      </div>
    </div>
  );
}
